import type { ComponentProps, FC } from 'react';
import { useNavigate } from 'react-router';

import { ButtonRow } from '../../components/global/ButtonRow/ButtonRow';
import { FlowStepWithContainer } from '../../components/layout/FlowStepWithContainer';
import { LinksForm } from '../../forms/event/Links/LinksForm.tsx';
import { getCurrentStepInfo, getNextStep } from './eventOnboardingFlow.ts';
import { useOnboardingIncompleteEvent } from './hooks/useOnboardingIncompleteEvent.ts';

export const EventLinks: FC = () => {
  const navigate = useNavigate();
  const currentStep = 'links';
  const { currentStep: stepNumber, totalSteps, label: heading } = getCurrentStepInfo(currentStep);

  const { query, mutation } = useOnboardingIncompleteEvent({
    onMutationSuccess: () => void navigate(`../${getNextStep(currentStep)}`),
  });

  const onSubmit: ComponentProps<typeof LinksForm>['onSubmit'] = ({
    ticketshopLink,
    instagramLink,
    spotifyLink,
    tiktokLink,
    websiteLink,
  }) => {
    mutation.mutate({
      ticketshopLink,
      instagramLink,
      spotifyLink,
      tiktokLink,
      websiteLink,
    });
  };

  if (!query.data) {
    return null;
  }

  return (
    <FlowStepWithContainer
      bodyContent={
        <LinksForm
          buttonSlot={
            <ButtonRow
              primaryButton={{
                type: 'submit',
                text: 'Next',
                isPending: mutation.isPending,
              }}
              secondaryButton={{
                text: 'Back',
                onClick: () => void navigate(-1),
              }}
            />
          }
          defaultValues={query.data}
          onSubmit={onSubmit}
        />
      }
      heading={heading}
      progress={{ currentStep: stepNumber, totalSteps }}
    />
  );
};
